import {TKey} from '@/translations/i18n'
import {MedicalReportType} from '@/types'
import {routes} from '@/utilities/constants/routes'
import dayjs from 'dayjs'
import {generatePath} from 'react-router-dom'

export const patientMedicalRecordReportToLabel = {
    signed: 'commons:signed',
    draft: 'commons:draft'
} as const satisfies Record<'signed' | 'draft', TKey>

export const formatDateToSearchParams = ({startDate, endDate}: {startDate: Date; endDate: Date}) => {
    return {
        startDate: dayjs(startDate).format('YYYY-MM-DD'),
        endDate: dayjs(endDate).format('YYYY-MM-DD')
    }
}

export const hasPassed5Minutes = (startTime: string | null): boolean => {
    if (!startTime) return false

    const now = dayjs()
    const startedAt = dayjs(startTime)
    const fiveMinutesAgo = now.subtract(5, 'minute')

    return startedAt.isBefore(fiveMinutesAgo)
}

/**
 * Navigate to create medical report page with appropriate search parameters
 */
export const generateMedicalRecord = (
    patientId: string,
    projectId?: string | null,
    medicalReportType?: MedicalReportType | null
): string | undefined => {
    if (!projectId) {
        return undefined
    }

    // Construct URL search params for navigation
    const createSearchParams = () => {
        const params = new URLSearchParams()

        if (projectId) {
            params.append('projectId', projectId)
        }

        if (medicalReportType) {
            params.append('medicalRecordReportTypeId', medicalReportType.id)
        }

        const searchString = params.toString()
        return searchString ? `?${searchString}` : ''
    }

    const path = generatePath(routes.PATIENT_DETAILS_MEDICAL_RECORDS.handle.path, {id: patientId})
    return `${path}${createSearchParams()}`
}
